import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import SupportButton from "../../../atoms/buttons/SupportButton";
import VestelLogo from "../../../atoms/images/VestelLogo";
import LanguageDropdown from "../../dropdowns/LanguageDropdown";
import useMediaQuery from "../../../../hooks/useMediaQuery";
import { useHeaderTitle } from "../../../../hooks/useHeaderTitle";
import Text from "../../content/Text";

const Header = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const isMobile = useMediaQuery("(max-width: 768px)");
  const { title } = useHeaderTitle();

  return (
    <header className="flex items-center justify-between px-4 py-2 shadow-lg bg-white h-16 md:h-20 header-container z-20">
      <SupportButton />

      {title && isMobile ? (
        <Text variant={"bold"}>{title}</Text>
      ) : (
        <a className="text-center cursor-pointer" onClick={() => navigate("/")}>
          <VestelLogo className="mx-auto" />
          <p className="font-league-bold text-vestelColor text-sm pt-1">
            {isMobile
              ? t("layout.account")
              : t("layout.vestel-user-management")}
          </p>
        </a>
      )}

      <LanguageDropdown />
    </header>
  );
};

export default Header;
